// extracted by mini-css-extract-plugin
export default {"root":"_6Mdvp0","LinesMenuButtonNSkin":"e5RdhV","linesMenuButtonNSkin":"e5RdhV","linkElement":"KIbdSF","wrapper":"ZbB2Jv","label":"pt33b1"};